import { Provider } from '../PreCheckedProviders.types'

interface CheckSameFacilitiesAndProvidersParams {
  providerName: string
  listToCheck: Provider[]
}

/**
 * Accepts the provider and returns true if all of the providerNames in the list
 * of providers are the same
 *
 * @param providerName - The provider name to check against
 * @param listToCheck - Array of providers to validate
 * @returns True if all provider names match the given providerName
 */
export const checkSameFacilitiesAndProviders = ({
  providerName,
  listToCheck,
}: CheckSameFacilitiesAndProvidersParams): boolean => {
  if (listToCheck.length === 0) return false

  // Use the 'every' method to check if all provider names match the
  // providerNames from the list to check
  const allMatch = listToCheck.every(
    provider => provider?.providerName === providerName,
  )

  return allMatch
}
